import type { OutgoingAction } from '../../../../services/workQueue';
import { DESIGN_EXPIRED_STATUS_ID } from '../../constants.ts';

// Expire is a global action, so Pending approval has no edge for it.
const EXPIRE_COMPLETION: OutgoingAction = {
    action: 'expire-stale-design',
    label: 'Expire case',
    actor: 'internal',
    direction: 'terminal',
    to: DESIGN_EXPIRED_STATUS_ID
};

export function approvalCompletion(
    actions: readonly OutgoingAction[],
    actionId: string
): OutgoingAction | undefined {
    if (actionId === EXPIRE_COMPLETION.action) return EXPIRE_COMPLETION;
    return actions.find((a) => a.action === actionId);
}
